import http from "axios";
import storage from "../api/storage.js";
import router from "../router";
http.defaults.timeout = 15000;

function checkError(error) {
  if (error.response && error.response.status == 401) {
    const requestToken = error.config && error.config.headers && error.config.headers['x-access-token'];
    if(requestToken && requestToken !== storage.loadToken()) return;
    storage.saveAuthenticated(false);
    storage.removeItemsSessionStorage();
    if(router.currentRoute.name !== 'login') router.replace({ name: "login" });

  }
}

export async function login(username, pass) {
  return await http.post(`${process.env.VUE_APP_API_URL}/auth/login`, {
    username: username,
    pass: pass,
  });
}
export async function changePassword(body){
  try{return (await http.post(process.env.VUE_APP_API_URL+'/auth/password',body,{headers:{'x-access-token':storage.loadToken()}})).data;}
  catch(error){checkError(error);throw error;}
}
export async function deleteBackup(id){try{return (await http.delete(process.env.VUE_APP_API_URL+'/gestion/backups/'+id,{headers:{'x-access-token':storage.loadToken()}})).data;}catch(error){checkError(error);throw error;}}
export async function createBackup(){try{return (await http.post(process.env.VUE_APP_API_URL+'/gestion/backups',{}, {timeout:300000,headers:{'x-access-token':storage.loadToken()}})).data;}catch(error){checkError(error);throw error;}}
export async function getBackups(){try{return (await http.get(process.env.VUE_APP_API_URL+'/gestion/backups',{headers:{'x-access-token':storage.loadToken()}})).data;}catch(error){checkError(error);throw error;}}
export async function restoreBackup(id,body){try{return (await http.post(process.env.VUE_APP_API_URL+'/gestion/backups/'+id+'/restore',body,{timeout:300000,headers:{'x-access-token':storage.loadToken()}})).data;}catch(error){checkError(error);throw error;}}
export async function downloadBackup(id){try{return (await http.get(process.env.VUE_APP_API_URL+'/gestion/backups/'+id+'/download',{responseType:'blob',timeout:300000,headers:{'x-access-token':storage.loadToken()}})).data;}catch(error){checkError(error);throw error;}}
export async function getStatistics(days=30){
  try{const result=await http.get(process.env.VUE_APP_API_URL+'/gestion/statistics',{params:{days},headers:{'x-access-token':storage.loadToken()}});return result.data;}
  catch(error){checkError(error);throw error;}
}

export async function getCarta() {
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.get(
      `${process.env.VUE_APP_API_URL}/gestion/carta`,
      config
    );
    return res.data.carta;
  } catch (error) {
    checkError(error);
    throw error;
  }
}

export async function getCartaCompleta() {
  try {
    const result = await http.get(process.env.VUE_APP_API_URL + "/gestion/carta",
      { headers: { "x-access-token": storage.loadToken() } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}
export async function getRestaurantProfile() {
  try {
    const result = await http.get(process.env.VUE_APP_API_URL + "/gestion/perfil", { headers: { "x-access-token": storage.loadToken() } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}
export async function setRestaurantProfile(profile) {
  try {
    const result = await http.post(process.env.VUE_APP_API_URL + "/gestion/perfil", profile, { headers: { "x-access-token": storage.loadToken() } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}
export async function setCarta(data, version) {
  try {
    const result = await http.post(process.env.VUE_APP_API_URL + "/gestion/carta",
      { carta: data, version }, { headers: { "x-access-token": storage.loadToken() } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}

export async function getEnableCarta()
{
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.get(
      `${process.env.VUE_APP_API_URL}/gestion/carta`,
      config
    );
    return res.data.enableCarta;
  } catch (error) {
    checkError(error);
  }
}

export async function getUrl()
{
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.get(
      `${process.env.VUE_APP_API_URL}/gestion/carta`,
      config
    );
    console.log(res);
    return res.data.url;
  } catch (error) {
    checkError(error);
  }
}

export async function getAlergenos() {
  return await (
    await http.get(`${process.env.VUE_APP_API_URL}/recursos/alergenos`)
  ).data.alergenos;
}

export async function getIconos() {
  return await (
    await http.get(`${process.env.VUE_APP_API_URL}/recursos/iconos`)
  ).data.iconos;
}

export async function getBuiran() {
  return await (
    await http.get(`${process.env.VUE_APP_API_URL}/recursos/buiran`)
  ).data.logo;
}
export async function getMenu() {
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.get(
      `${process.env.VUE_APP_API_URL}/gestion/menu`,
      config
    );
    return res.data.menu;
  } catch (error) {
    checkError(error);
  }
}
export async function setMenu(data, version) {
  try {
    const result = await http.post(process.env.VUE_APP_API_URL + "/gestion/menu",
      { menu: data, version }, { headers: { "x-access-token": storage.loadToken() } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}
export async function getPlatosMenu() {
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.get(
      `${process.env.VUE_APP_API_URL}/gestion/gruposmenu`,
      config
    );
    return res.data.gruposmenu;
  } catch (error) {
    checkError(error);
  }
}
export async function setPlatosMenu(data) {
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.post(
      `${process.env.VUE_APP_API_URL}/gestion/gruposmenu`,
      { gruposmenu: data },
      config
    );
    return res.data.gruposmenu;
  } catch (error) {
    checkError(error);
  }
}

export async function getDataBusiness() {
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.get(
      `${process.env.VUE_APP_API_URL}/gestion/data`,
      config
    );
    return res.data;
  } catch (error) {
    checkError(error);
  }
}

export async function setDataBusiness(data) {
  let config = {
    headers: {
      "x-access-token": await storage.loadToken(),
    },
  };
  try {
    let res = await http.post(
      `${process.env.VUE_APP_API_URL}/gestion/data`,
       data,
      config
    );
    return res.data;
  } catch (error) {
    checkError(error);
  }
}

export async function setMenuCompleto(gruposmenu, menu, version) {
  try {
    const result = await http.post(process.env.VUE_APP_API_URL + "/gestion/menucompleto",
      { gruposmenu, menu, version }, { headers: { "x-access-token": storage.loadToken() } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}

export async function getMenuCompleto() {
  try {
    const result = await http.get(process.env.VUE_APP_API_URL + "/gestion/menucompleto",
      { headers: { "x-access-token": storage.loadToken() } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}

export function imageUrl(image) {
  if (!image) return "";
  if (!image.startsWith("/recursos/platos/")) return "";
  return process.env.VUE_APP_API_URL.replace(/\/api\/?$/, "") + image;
}
export async function uploadDishImage(blob) {
  try {
    const result = await http.post(process.env.VUE_APP_API_URL + "/gestion/imagen", blob,
      { headers: { "x-access-token": storage.loadToken(), "Content-Type": "application/octet-stream" } });
    return result.data;
  } catch (error) { checkError(error); throw error; }
}
